const ABProcessEndCore = require("../../../core/process/tasks/ABProcessEndCore");
module.exports = class ABProcessEnd extends ABProcessEndCore {};
